const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Henter en hel kollektion som et simpelt array (velegnet til mindre, faste lister)
 */
export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`${BASE_URL}/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.error(`Error fetching collection ${collectionName}:`, err);
    return [];
  }
}

/**
 * Henter en kollektion via v2 endpointet med understøttelse af filtrering, sortering og paginering
 */
export async function fetchCollectionV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${BASE_URL}/v2/content/${collectionName}?${query}`);
    if (!res.ok) throw new Error(`Failed to fetch v2 ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.error(`Error fetching v2 collection ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

/**
 * Henter et enkelt element baseret på dets sprog og slug
 */
export async function fetchEntryBySlug(lang, slug) {
  try {
    const res = await fetch(`${BASE_URL}/by-slug/${lang}/${slug}`);
    if (!res.ok) throw new Error(`Failed to fetch entry by slug: ${slug}`);
    return await res.json();
  } catch (err) {
    console.error(`Error fetching entry by slug ${slug} (${lang}):`, err);
    return null;
  }
}
